import { gql } from 'apollo-boost'

const UPDATE_SCRAPING_TAG = gql`
  mutation updateScrapingTag($id: ID!, $name: String!) {
    updateScrapingTag(id: $id, name: $name) {
      id
      name
    }
  }
`

export default UPDATE_SCRAPING_TAG
